import { DateTime } from "luxon";

export enum SubscriptionStatus {
    FreePremium = 'FreePremium',
    PaidPremium = 'PaidPremium',
    Expired = 'Expired'
}

export interface UserSubscription {
    hasPremiumTier: boolean;
    status: SubscriptionStatus;
    premiumExpiryDate: DateTime;
} 